// Constants for localStorage keys
export const KEYS = {
  LOGIN_TOKEN_STORE_KEY: 'access_token',
  REFRESH_TOKEN_KEY: 'refresh_token',
} as const;
